import script from "./AssinaturaRepository.vue?vue&type=script&lang=js"
export * from "./AssinaturaRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__